var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quoteData)?_c('div',{staticClass:"mr-1",staticStyle:{"width":"1024px"},attrs:{"color":"white"}},[_c('ctlQuoteDoc',{attrs:{"quoteData":_vm.quoteData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }